const dateFormatter = (value, options) => {
  const result = new Date(value).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    ...options,
  });
  return result;
};

export default dateFormatter;
